import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './MyAccountTag.module.sass'


interface Props {
  label: string
  variant?: 'bg' | 'border'
  color?: 'primary' | 'danger' | 'warning' | 'dark-grey'
  className?: string
}

const MyAccountTag = (props: Props) => {

  const { 
    label,
    variant = 'bg',
    color = 'primary',
    className = '',
  } = props

  return label ? (
    <div className={cn(styles.root, styles[`root--${variant}`], styles[`root--${color}`], className)}>
      {label}
    </div>
  ) : <></>
}

export default MyAccountTag
